import { flow } from 'lodash';
import { NAME } from './dialogs.constant';

import { selectState as selectStateDebts } from '../debts.selector';

const selectStateKey = (state) => state[NAME];

export const selectState = flow(selectStateDebts, selectStateKey);
